import React from "react"

function VolumeAndRevenue(){
    return <React.Fragment>
        <iframe title="Vol and Rev Data_Test" width="1400" height="800" src="https://app.powerbi.com/reportEmbed?reportId=f62b3f9d-0ca5-4022-89e3-eb361aa182fa&autoAuth=true&ctid=49423d5d-8d49-4128-b53d-59537808f6ac&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtYi1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldC8ifQ%3D%3D" allowFullScreen={true}></iframe>
    </React.Fragment>
}

export{VolumeAndRevenue}